import React from "react";
import icons from "../../../../../assets/images/icons";
import BackHeader from "../BackHeader/BackHeader";
import styles from "./ChatHeader.module.scss";
/**
 * Chat header — Figma MCP 기준
 * type="main": 40004342:65567 (제목 + 휴지통/설정/닫기)
 * type="delete": 40004344:48464 (동일 레이아웃: 제목 + 휴지통/설정/닫기, 0.0.4 삭제 화면)
 */
function ChatHeader({
  className = "",
  title = "",
  type = "main",
  showTrash,
  onTrashClick,
  onSettingClick,
  onCloseClick,
  onCancelDelete,
  onConfirmDelete,
  onBackClick,
}) {
  const isDelete = type === "delete";

  return (
    <div
      className={`${styles.root} ${className}`.trim()}
      data-name="Chat header"
      data-node-id={isDelete ? "40004344:48464" : "40004342:65567"}
    >
      <div className={styles.bar}>
        {!isDelete ? (
          <div className={styles.nav}>
            <div className={styles.content}>
              <div className={styles.wrapper}>
                <div className={styles.section}>
                  <h1 className={styles.title}>{title}</h1>
                </div>
                <div className={styles.trailing}>
                  {showTrash && (
                    <button
                      type="button"
                      className={styles.iconBtn}
                      onClick={isDelete ? onConfirmDelete : onTrashClick}
                      aria-label={isDelete ? "삭제하기" : "삭제"}
                    >
                      <img
                        src={icons.messager?.trash}
                        alt=""
                        className={styles.iconImg}
                        width={24}
                        height={24}
                      />
                    </button>
                  )}
                  <button
                    type="button"
                    className={styles.iconBtn}
                    onClick={onSettingClick}
                    aria-label="설정"
                  >
                    <img
                      src={icons.messager?.setting}
                      alt=""
                      className={styles.iconImg}
                      width={24}
                      height={24}
                    />
                  </button>
                  <button
                    type="button"
                    className={styles.iconBtn}
                    onClick={isDelete ? onCancelDelete : onCloseClick}
                    aria-label={isDelete ? "취소" : "닫기"}
                  >
                    <img src={icons.messager?.close} alt="" className={styles.iconBtnClose} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <BackHeader title={title} type="delete" onBackClick={onBackClick} />
        )}
        <div className={styles.divider} />
      </div>
    </div>
  );
}

export default ChatHeader;
